
  import { TodoRecord, Type } from '@/entities/todo';
  import { listTodo } from '@/services/api/resources/todo';
  import { openTodo } from '@/services/todo/todoService';
  import Widget, { CollapsibleProperties } from '@/ui/components/home/Widget.vue';
  import StaticPagination from '@/ui/components/StaticPagination.vue';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import OverdueTag from '@/ui/components/tag/OverdueTag.vue';
  import { useTask } from '@/ui/concerns';
  import { useQueries } from '@/ui/pages/dashboard/useQueries';
  import { defineComponent, ref, watch } from 'vue';
  import { Loader } from '@/ui/components/Loader';
  import { Tag } from '@/ui/components/Tag';

  const TODOS_COUNT = 5;

  export default defineComponent<CollapsibleProperties>({
    components: {
      Tag,
      Widget,
      OverdueTag,
      Loader,
      ResourceTable,
      Pagination: StaticPagination,
    },
    props: ['collapsible'],
    setup() {
      const todos = ref<TodoRecord[]>([]);
      const page = ref(1);
      const total = ref(0);
      const isEmpty = ref(false);

      const { inProgressQuery } = useQueries();

      const getTodosTask = useTask(
        () => listTodo(inProgressQuery({
          page: page.value,
          perPage: TODOS_COUNT,
        })),
        response => {
          todos.value = response.data;
          total.value = response.meta.total;
          isEmpty.value = todos.value.length === 0;
        },
      );

      const onPageChanged = (value: number) => {
        page.value = value;
      };

      watch([page], () => getTodosTask.run({ page: page.value }));

      return {
        getTodosTask,
        todos,
        page,
        perPage: TODOS_COUNT,
        total,
        onPageChanged,
        TYPE_ISSUE: Type.Issue,
        openTodo,
        isEmpty,
      };
    },
  });
